<!-- I18nTableColumn.vue -->
<template>
  <el-table-column v-bind="$attrs" :label="computedLabel">
    <slot />
    <template v-for="(_, name) in $slots" #[name]>
      <slot :name="name" />
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'I18nTableColumn',
  inheritAttrs: false,
  computed: {
    computedLabel() {
      const labelKey = this.$attrs.label;
      // 如果 label 是字符串，就当翻译 key 处理
      return typeof labelKey === 'string' ? this.$t(labelKey) : labelKey;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/I18n/I18nTableColumn.vue